import { render, staticRenderFns } from "./FeedingStyle.vue?vue&type=template&id=64aad157&"
import script from "./FeedingStyle.vue?vue&type=script&lang=js&"
export * from "./FeedingStyle.vue?vue&type=script&lang=js&"
import style0 from "./FeedingStyle.vue?vue&type=style&index=0&id=64aad157&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports